import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface CustomerListHolderCompanyNameHeaderProps
  extends HeaderContext<
    GatewayCustomerModel,
    NonNullable<GatewayCustomerModel['holder']>['companyName'] | undefined
  > {}

export const CustomerListHolderCompanyNameHeader =
  (): // props: CustomerListHolderCompanyNameHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-holder.company-name');
  };
